import { getExpectedOutput } from "../Data/ProblemsMethod";


export const gradeResponseWithRegex = (responseJSON, problemID) => {
    try{
        const submissions = responseJSON?.data?.submissions;
        const expctedOutput = getExpectedOutput(problemID);
        let n = submissions.length;
        for(let i = 0; i < n; i++){
            try{

                const output = submissions[i].stdout // Entire output string
                const regex_functionReturnValue = /(?<=93Alpha)(.*?)(?=Omega93)/g; // Regex to extract only the function return bounded by special sequence
                const functionReturnValue = output.match(regex_functionReturnValue)[0].trim(); 
                const status = functionReturnValue === expctedOutput[i] ? "Accepted" : "Failed";
                responseJSON.data.submissions[i].status.description = status
                responseJSON.data.submissions[i]["functionReturnValue"] = functionReturnValue;

                const regex_STDOUT = /(.*?)93Alpha.*?Omega93(.*)/s; // Regex to extract everthing outside sepcial sequence, ie user print statements 
                const match = output.match(regex_STDOUT);
                if(match){
                    const userPrint = (match[1] + match[2]) // Removes leading and trailing whitespace, which includes spaces, tabs, and newlines
                    responseJSON.data.submissions[i]["userPrint"] = userPrint
                }

            }catch(err){
                console.log("[ERROR] in gradeResponse: ", err )
            }
        }
        console.log("JSON after gradeResponseWithRegex:  ", responseJSON)
    }catch(err){
        console.log("[ERROR] in gradeResponse: ", err )
    }
}